import { useEventListener } from "primereact/hooks";
import { DomHandler } from "primereact/utils";
import { useCallback, useContext, useEffect, useRef } from "react";
import { LayoutContext } from "../context/layoutcontext";
import { MenuContext } from "../context/menucontext";

export const useSubmenuOverlayPosition = ({
  target,
  overlay,
  container,
  when,
}) => {
  const { isSlim, isCompact, isHorizontal, setLayoutState } =
    useContext(LayoutContext);
  const { activeMenu } = useContext(MenuContext);
  const [bindScrollListener, unbindScrollListener] = useEventListener({
    type: "scroll",
    target: container,
    listener: () => {
      setLayoutState((prevLayoutState) => ({
        ...prevLayoutState,
        overlayMenuActive: false,
        overlaySubmenuActive: false,
        staticMenuMobileActive: false,
        menuHoverActive: false,
        resetMenu: true,
      }));
    },
  });

  const calculatePosition = useCallback(() => {
    if (overlay) {
      const { left, top } = target.getBoundingClientRect();
      const { height: vHeight } = DomHandler.getViewport();
      const oHeight = overlay.offsetHeight;

      overlay.style.top = overlay.style.left = "";

      if (isHorizontal()) {
        overlay.style.left = `${left - 80}px`;
      } else if (isSlim() || isCompact()) {
        const height = top + oHeight;
        overlay.style.top =
          vHeight < height ? `${top - (height - vHeight)}px` : `${top}px`;
      }
    }
  }, [overlay, target, isHorizontal, isSlim, isCompact]);

  // primereact's useEventListener returns plain functions, so bind/unbind get a
  // fresh identity every render. Held in refs so the listener is bound and
  // unbound only when `when` flips, rather than churning on every render.
  const bindRef = useRef(bindScrollListener);
  const unbindRef = useRef(unbindScrollListener);
  bindRef.current = bindScrollListener;
  unbindRef.current = unbindScrollListener;

  useEffect(() => {
    when && bindRef.current();

    return () => {
      unbindRef.current();
    };
  }, [when]);

  useEffect(() => {
    when && calculatePosition();
  }, [when, activeMenu, calculatePosition]);
};
